// @flow
import { useContext } from 'react';
import { useMutation, MutationOptions } from 'react-query';
import { postHouseholdV2 } from 'services/householdService';
import { AppContext } from 'contexts/AppContext';
import { UserContext } from 'contexts/UserContext';

type Props = {
  options: MutationOptions,
};
const useCreateHouseholdMutation = ({ options }: Props = {}) => {
  const {
    organizationId,
    propertyId,
    marketingInfo: { propertyClass },
  } = useContext(AppContext);
  const {
    userProfile: { portalUserId },
  } = useContext(UserContext);

  return useMutation(
    () =>
      postHouseholdV2(
        organizationId,
        propertyId,
        portalUserId,
        propertyClass, // householdType,
        options,
      ),
    { ...options, enabled: Boolean(propertyClass) },
  );
};

export default useCreateHouseholdMutation;
